import React from 'react';
import SampleList from "../modularScale/SampleList";
import BodyTypeTester from "../bodyScale/BodyTypeTester";

const Main = () => {
  return (
    <main>
      <SampleList />
      <BodyTypeTester />
    </main>
  );
};

export default Main;